<template>
  <div class="company_module module_item company_module1">
    <div class="search">
      <el-cascader
        :options="v2CountryList"
        :props="propsNew"
        v-model="companyData.country"
        @change="emitSearch"
        ref="cInput"
        placeholder="Country"
        class="module_search_select1"
      ></el-cascader>
      <!--  -->
      <el-cascader
        :options="exChangeOps"
        :props="propsExChange"
        filterable
        v-model="companyData.stockExchange"
        @change="emitSearch"
        ref="cInput"
        placeholder="All"
        class="module_search_select1"
      ></el-cascader>
      <!--  -->
      <!-- <el-select
        v-model="companyData.stockExchange"
        filterable
        no-match-text="No data was found"
        no-data-text="No data was found"
        placeholder="All Stock Exchange"
        class="module_search_select1"
        @change="emitSearch"
      >
        <el-option
          v-for="item in exChangeOps"
          :key="item.code"
          :label="item.name"
          :value="item.name"
        ></el-option>
      </el-select> -->
      <div class="resetBtn">
        <i class="el-icon-refresh" @click="resetCondiction" title="reset"></i>
        <!-- <el-button type="text" @click="resetCondiction">Reset</el-button> -->
      </div>
    </div>

    <div class="total-top">
      Total
      <span class="totalCls">{{total}}</span> records
    </div>

    <div class="list_resullt" v-if="lists.length">
      <div
        class="result_item"
        v-for="(item,index) of lists"
        :key="index"
        @click="searchData(item)"
        :class="{activeModuleCls:active==item.fid}"
      >
        <div class="item_title">
          <span class="title">{{item.company_name}}</span>
          <!-- <slot name="tag" :item="item"></slot> -->
          <span
            class="companyTag"
            v-if="item.stock_exchange_listed != 'Unlisted' && companyTagMap(item.civilListed)"
          >{{companyTagMap(item.civilListed)}}</span>
        </div>
        <div class="detail">
          <p v-for="(list,j) of detailLists" :key="j" class="detail_item">
            <span>{{list.label}}:&nbsp &nbsp</span>
            <span>{{item[list.key]}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="list_resullt" v-else>
      <div class="noData no_data_container">
        <span class="img no_data_img"></span>
        <p>Sorry, No data was found</p>
      </div>
    </div>

    <div class="page_footer clearfix">
      <!-- <p class="total_page">
        Total
        <span class="totalCls">{{total}}</span> records
      </p>-->
      <el-pagination
        :total="total"
        background
        layout="prev, pager, next"
        :current-page="companyData.page"
        :pager-count="5"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import SearchList from "../SearchList";
import { getNation, getExchanges } from "common/js/http/v2Api";
import debounceMixin from "common/js/mixin/debounce";
import { mapState, mapMutations } from "vuex";

const detailLists = [
  {
    label: "Legal representative",
    key: "legal" //后台字段
  },
  {
    label: "Date of establishment",
    key: "establishment_date" //后台字段
  },
  {
    label: "Phone Number",
    key: "phone" //后台字段
  },
  {
    label: "Address",
    key: "office_address" //后台字段
  }
];

export default {
  components: {
    SearchList
  },

  props: ["lists", "total"],

  mixins: [debounceMixin],

  data() {
    return {
      loading: true,
      // options2,
      detailLists, //每个模块的字段不同
      companyData: {
        country: [],
        stockExchange: ["Listed","Shanghai Stock Exchange"],
        mainIndustry: "",
        page: 1,
        size: 10
      },
      country: "",
      props: {
        lazy: true,
        lazyLoad: async (node, resolve) => {
          const { level } = node;
          let id;
          if (node.level == 0) {
            id = 0;
          } else id = node.data.id;
          const res = await getNation(id);

          const nodes = res.result.map(item => ({
            id: item.id,
            value: item.name,
            label: item.name,
            leaf: level >= 1
          }));
          resolve(nodes);
        }
      },
      propsNew: {
        label: "enName",
        value: "enName"
      },
      propsExChange: {
        label: "name",
        value: "name"
      },

      // 股票交易所
      exChangeOps: [],
      exChange: "",
      searchValue2: "",

      // list: [],
      totalCount: 0,
      active: ""
    };
  },

  created() {
    this.getExchangeOp();
  },

  mounted() {
    this.emitSearch();
  },

  methods: {
    // 股票交易所
    async getExchangeOp() {
      let defaultExchange = [
        {
          name:'Listed',
          children:[]
        },
        {
          name:'Unlisted'
        }
      ]
      const { result } = await getExchanges();
      result.unshift({
        name:'All Listed'
      })
      defaultExchange[0].children = result;
      this.exChangeOps = defaultExchange;
    },

    emitSearch() {
      let data = this.$lodash.cloneDeep(this.companyData);
      // 级联菜单获取的是数组  取最后一项
      let countryData;
      if (data.country.length > 0) {
        countryData = data.country[data.country.length - 1];
      } else countryData = "";
      // 
      // 级联菜单获取的是数组  取最后一项
      let exchangeData;
      if (data.stockExchange.length > 0) {
        exchangeData = data.stockExchange[data.stockExchange.length - 1];
        if(exchangeData == 'Unlisted') {
          exchangeData = "UNLISTED"
        }
        else if(exchangeData == 'All Listed') {
          exchangeData = 'LISTED'
        }
      } else exchangeData = "";

      data = Object.assign(data, { country: countryData,stockExchange: exchangeData});
      this.$emit("search", "company", data);
    },

    searchData(item) {
      this.active = item.fid;
      //没有数据权限
      if (!this.allKey.COMPANY_DETAIL) {
        this.$message({
          message: "Sorry, there are no permissions !",
          type: "warning"
        });
        return;
      }

      //关闭主页显示
      this.changeIndexShow(false);
      this.setLeftCollapse();
      this.$router.push({
        path: "/data/SearchModule/Company",
        query: {
          id: item.fid,
          code: item.securities_code,
          companyName: item.company_name
        }
      });
    },

    handleCurrentChange(val) {
      this.companyData.page = val;
      this.emitSearch();
    },

    companyTagMap(civilListed) {
      const map = {
        0: "Listed in China",
        1: "Listed in HongKong",
        // 2: "Listed Abroad",
        3: "Listed in Shanghai",
        4: "Listed in Shenzhen"
      };
      return map[civilListed];
    },

    resetCondiction() {
      this.companyData = {
        country: [],
        stockExchange: "",
        // mainIndustry: "",
        page: 1,
        size: 10
      };
      this.emitSearch();
    },

    ...mapMutations(["changeIndexShow"])
  },

  computed: {
    ...mapState({
      v2CountryList(state) {
        return state.v2Permission.v2CountryList;
      },
      allKey(state) {
        return state.v2Permission.v2CurrentPermission;
      }
    })
  },

  watch: {
    // total(newValue) {
    //   this.total = total;
    // }
    // commonList: {
    //   handler(newValue) {
    //   },
    //   deep: true
    // }
  }
};
</script>

<style scoped>
.list_resullt {
  margin-top: 10px;
  height: calc(100% - 190px);
  overflow-y: auto;
  padding: 0px 10px 0px 0px;
}

.page_footer >>> .el-pagination {
  float: right;
}

.total_page {
  float: left;
  height: 32px;
  line-height: 32px;
}

.page_footer {
  border-top: 1px solid #dee2e6;
  padding-top: 16px;
}
.totalCls {
  color: #4a12b7;
  display: inline-block;
  padding: 0px 3px;
  font-weight: 600;
}
.item_title {
  position: relative;
}
.companyTag {
  position: absolute;
  right: 20px;
  font-weight: 600;
  padding: 2px 5px;
  border: 1px solid #aaaebb;
  border-radius: 13px;
  color: #9e9e9e;
}
.total-top {
  padding-top: 10px;
}
</style>